export default __webpack_public_path__ + "static/media/coaching2.760ef303.jpg";